var _a;
import { useState } from 'react';
import { useIsomorphicLayoutEffect } from './useIsomorphicLayoutEffect';
const mediaQuery = (_a = window === null || window === void 0 ? void 0 : window.matchMedia) === null || _a === void 0 ? void 0 : _a.call(window, '(prefers-color-scheme: dark)');
export function usePrefersColorScheme() {
    const [preferredColorScheme, setPreferredColorScheme] = useState((mediaQuery === null || mediaQuery === void 0 ? void 0 : mediaQuery.matches) ? 'dark' : 'light');
    useIsomorphicLayoutEffect(() => {
        if (!mediaQuery) {
            return;
        }
        function onChange(event) {
            setPreferredColorScheme(event.matches ? 'dark' : 'light');
        }
        if (mediaQuery.addEventListener) {
            mediaQuery.addEventListener('change', onChange);
        }
        else if (mediaQuery.addListener) {
            mediaQuery.addListener(onChange);
        }
        return () => {
            if (mediaQuery.removeEventListener) {
                mediaQuery.removeEventListener('change', onChange);
            }
            else if (mediaQuery.removeListener) {
                mediaQuery.removeListener(onChange);
            }
        };
    }, []);
    return preferredColorScheme;
}
//# sourceMappingURL=usePrefersColorScheme.js.map